import { FormGroupState, FormArrayState } from 'ngrx-forms';
import { isEmpty } from 'lodash';

import { ValidationSummary } from '../_models/validation-summary.model';
import { addValidation } from './validation.util';
/* eslint-disable @typescript-eslint/no-explicit-any */

export const getAllNgrxErrors = (form: FormGroupState<any> | FormArrayState<any>) => {
  const errorSummary = Object.keys(form.controls).reduce((acc, key) => {
    const nkey = Number(key);
    const isArray = !isNaN(nkey);

    let control;
    if (isArray) {
      form = form as FormArrayState<any>;
      control = form.controls[nkey];
    } else {
      form = form as FormGroupState<any>;
      control = form.controls[key];
    }

    if (control) {
      let validation: ValidationSummary = { key, control };
      if (control.errors) {
        let { errors } = control;
        errors = Object.keys(errors)
          .filter(k => !k.startsWith('_'))
          .reduce((obj, k) => (obj[k] = { [k]: errors[k] }), {} as any);

        if (!isEmpty(errors)) {
          validation = { ...validation, errors };
        }

        if (control.hasOwnProperty('controls')) {
          control = control as FormGroupState<any> | FormArrayState<any>;
          validation = { ...validation, children: getAllNgrxErrors(control) };
        }
      }

      acc = addValidation(acc, validation);
    }

    return acc;
  }, [] as ValidationSummary[]);

  return errorSummary;
};
